"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCsrfCookieName = void 0;
/**
 * Возвращает имя куки, в которой будет храниться CSRF-токен
 */
function getCsrfCookieName(appId) {
    return appId + "-csrf-token";
}
exports.getCsrfCookieName = getCsrfCookieName;

//# sourceMappingURL=get-csrf-cookie-name.js.map
